/* eslint-disable no-underscore-dangle */
export function findParentNode(instance) {
  function re(inst) {
    if (inst.__canvas_node) {
      return inst;
    }

    if (inst.parent) {
      return re(inst.parent);
    }

    // console.error('vue error: Can not find parent node');
    return {};
  }

  return re(instance.parent);
}

export function findParentApplication(instance) {
  function re(inst) {
    if (inst.__canvas_node && inst.__canvas_node.canvas) {
      return inst;
    }

    if (inst.parent) {
      return re(inst.parent);
    }

    // console.error('vue error: Can not find parent application node');
    return {};
  }

  return re(instance.parent);
}

export default findParentNode;
